import React from 'react';
import IconLink from "../Item/IconLink";
import {BROKER, VENDOR} from "../../services/constants/CompanyType";
import {useLocation} from "react-router-dom";
import {ADMIN} from "../../services/constants/VendorAccountPrivilegues";

const SideMenu = ({userData, baseUrl, company}) => {
    let sideMenu = [];
    switch (userData.type) {
        case BROKER:
            if (userData.is_primary || ([ADMIN].includes(company.privileges))) {
                sideMenu.push({
                    icon: 'Home', text: 'Company info', href: `${baseUrl}/account/settings/company-info`,
                });
            }
            sideMenu.push({
                icon: 'User', text: 'Personal info', href: `${baseUrl}/account/settings/personal-info`,
            });
            sideMenu.push({
                icon: 'Users', text: 'Downloads', href: `${baseUrl}/account/settings/downloads`,
            });
            if (userData.is_primary || ([ADMIN].includes(company.privileges))) {
                sideMenu.push({
                    icon: 'Users', text: 'Users', href: `${baseUrl}/account/settings/users`,
                });
                sideMenu.push({
                    icon: 'Flag', text: 'Flags', href: `${baseUrl}/account/settings/custom-flags`,
                });
                sideMenu.push({
                    icon: 'Database', text: 'Repository', href: `${baseUrl}/account/settings/resources`,
                });
                sideMenu.push({
                    icon: 'Search', text: 'Search ordering', href: `${baseUrl}/account/settings/search-ordering`,
                });
            }
            sideMenu.push({
                icon: 'RefreshCw', text: 'Update requests', href: `/broker/update-requests`,
            });
            break;
        case VENDOR:
            break;
        default:
            userData = [];
    }

    const location = useLocation();
    const currentPath = location.pathname;

    return (<ul className="sl-sidebar sl-pl-0">
        {sideMenu.map((item, index) => (
            <li className="sidebar-settings">
                <IconLink icon={item.icon} text={item.text} href={item.href} size={16}
                          linkClass={`sl-sidebar-btn sl-no-underline ${item.href === currentPath ? 'active' : ''}`}/>
            </li>
        ))}
    </ul>);
};

export default SideMenu;
